import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OfferTagComponent } from './offer-tag.component';
import { MatIconModule } from '@angular/material/icon';
import { SharedModule } from '../../shared/shared.module';


@NgModule({
  declarations: [
    OfferTagComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    MatIconModule
  ],
  exports: [OfferTagComponent],
  bootstrap: [OfferTagComponent]
})
export class OfferTagModule { }
